export const notificationPeriods = {
    'now': 'Real Time',
    'day': 'Daily',
    'week': 'Weekly',
    'never': 'Never',
}
